import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import useMediaUrl from 'hooks/useMediaURL';
import PreviewCards from './PreviewCards';
import { Designs } from '../../constants/designTemplates';
import PlayIcon from '@mui/icons-material/PlayCircleFilledWhiteOutlined';
import DesignContainer from '../connect-card/DesignContainer';
import EditCardModal from './CardEditModal';

const useStyles = makeStyles(() => ({
  logo: {
    maxWidth: 120,
    maxHeight: 80,
  },
  video: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #e4e7eb',
    maxWidth: '275px',
    width: '100%',
    height: '160px',
    margin: 'auto',
    marginBottom: '20px',
    boxShadow: '0 0 2px 0 rgba(0, 0, 0, 0.2)',
  },
}));

const ConnectPointPreview = ({ data, cards, onUpdateConnectCard }) => {
  const [selected, setSelected] = useState(null);
  const account = useSelector((s) => s.settings.account);
  const color = data.primary_color || '#' + account.primary_color;
  const template = Designs[data.collection_template]
    ? data.collection_template
    : '1';

  const classes = useStyles({
    color,
    template,
    designTemplate: Designs[template],
  });

  const logoUrl = useMediaUrl(account.account_logo_url);

  const onSave = async (values) => {
    await onUpdateConnectCard(values);
    setSelected(null);
  };

  const {
    collection_title,
    collection_description,
    logo_or_video,
    logo_or_video_url,
  } = data;

  return (
    <DesignContainer template={template} color={color}>
      <Box p={3} textAlign="center">
        <Box>
          {logo_or_video === 'video' ? (
            <div className={classes.video}>
              <PlayIcon />
            </div>
          ) : logo_or_video_url || logoUrl?.url ? (
            <div className={classes.logoBox}>
              <img
                className={classes.logo}
                src={logo_or_video_url || logoUrl.url}
              />
            </div>
          ) : (
            <div className={classes.video}>Your Logo</div>
          )}
          <Typography gutterBottom variant="h2">
            {collection_title || 'Headline'}
          </Typography>
          <Typography paragraph color="textSecondary">
            {collection_description || 'Description'}
          </Typography>
        </Box>
        <Box mt={6} mb={6}>
          <PreviewCards color={color} cards={cards} onEdit={setSelected} />
        </Box>
        <Box>
          <Typography variant="caption" color="textSecondary">
            Powered by{' '}
            <Typography variant="caption" color="textPrimary" fontWeight={600}>
              Text In Church
            </Typography>
          </Typography>
        </Box>
      </Box>
      {selected && (
        <EditCardModal
          card={selected}
          onSave={onSave}
          onCancel={() => setSelected(null)}
        />
      )}
    </DesignContainer>
  );
};

export default ConnectPointPreview;
